<template>
  <InteractiveForm
    ref="rfPersonaFinanceForm"
    :steps="cptdFormSteps"
    :busy="busy"
    current-form="persona-finance"
    :auto-selectable-steps="autoSelectableSteps"
    @submit="submit"
  >
    <template #default="{ step, validation }">
      <YesOrNoCheckInput
        v-if="displayInput(step, 'annotated')"
        id="annotated"
        key="annotated"
        v-model="personaFinance.annotated"
        name="annotated"
        :label="cptdAnnotatedLabel"
        :helper-message="cptdAnnotatedHelperMessage"
        :validation="validation"
        :inverse="true"
        @input="autoSelectField('annotated', $event)"
      />
      <!-- RENDA -->
      <AmountInput
        v-if="displayInput(step, 'monthly_income')"
        id="monthly_income"
        key="monthly_income"
        v-model="personaFinance.monthly_income"
        class="field required"
        name="monthly_income"
        label="Qual é a sua renda mensal?"
        helper-message="Inclui o seu salário, ganhos como aluguéis, pensão, renda extra. É necessário comprovar a renda mensal no momento da contratação."
        :validation="validation"
        validations="required|greaterThan:0|lowerThan:50000"
      />
      <IncomeSourceRadioList
        v-if="displayInput(step, 'income_source')"
        id="incomeSource"
        key="incomeSource"
        v-model="personaFinance.income_source"
        title="Selecione a sua modalidade de trabalho"
        search-placeholder="Buscar modalidade"
        :validation="validation"
        @input="autoSelectField('income_source', $event)"
      />
    </template>
  </InteractiveForm>
</template>
<script>
import { nextTick } from 'vue'
import InteractiveForm from '@/components/forms/InteractiveForm.vue'
import AmountInput from '@/components/forms/fields/input/AmountInput.vue'
import IncomeSourceRadioList from '@/components/forms/fields/radioInputList/IncomeSourceRadioList.vue'
import YesOrNoCheckInput from '@/components/forms/fields/checkInput/YesOrNoCheckInput.vue'
export default {
  name: 'PersonaFinanceInteractiveForm',
  components: {
    AmountInput,
    IncomeSourceRadioList,
    YesOrNoCheckInput,
    InteractiveForm,
  },
  props: {
    busy: { type: Boolean, default: false },
    displaySteps: { type: Array, default: () => [] },
  },
  emits: ['submit'],
  data() {
    return {
      personaFinance: {
        annotated: '',
        income_source: '',
        monthly_income: '',
      },
      autoSelectableSteps: ['annotated', 'income_source'],
      steps: ['annotated', 'income_source', 'monthly_income'],
    }
  },
  computed: {
    cptdAnnotatedLabel() {
      return 'O seu nome está limpo?'
    },
    cptdAnnotatedHelperMessage() {
      return 'Estar com o nome limpo significa que você não possui restrições no Serasa, SPC, Boa Vista ou Quod.'
    },
    cptdFormSteps() {
      if (this.displaySteps?.length > 0) {
        return this.displaySteps
      }
      return this.steps
    },
  },
  methods: {
    autoSelectField(key, value) {
      this.personaFinance[key] = value
      nextTick(() => {
        this.$refs.rfPersonaFinanceForm.next()
      })
    },
    selectField(key, value) {
      this.personaFinance[key] = value
    },
    displayInput(step, key) {
      return step === key
    },
    submit() {
      this.$emit('submit', this.personaFinance)
    },
  },
}
</script>
<style lang="scss"></style>
